export default __webpack_public_path__ + "static/media/QK_9659.856a726d.jpg";